import { ReactNode } from 'react';
import styles from './styles.module.scss';

type Tooltip = {
  children: ReactNode,
  text: string
}

function Tooltip(props : Tooltip) : JSX.Element {
  if(!props.text || props.text === '') {
    return (
      <>
        {props.children}
      </>
    );
  }

  return (
    <div className={styles['biobar-tooltip']}>
      {props.children}
      <span className={styles['biobar-tooltipText']}>{props.text}</span>
    </div>
  );
}

export default Tooltip;